import React, {Fragment,useState,useRef} from 'react';
import { useEffect } from 'react';
import {
    Table,Col, Row, Card, CardBody,
    CardTitle, Button, Form, FormGroup, Label, Input , Modal
} from 'reactstrap';
import Parametri from '../../parametri';
import TendinaEditabile from '../TendinaEditabile.js';
import Clessidra from '../Clessidra.js';
import Modale from '../Modale.js';
import FinestraDialogo from '../FinestraDialogo.js';

const STATO_INDEFINITO = 0;
const STATO_INSERISCI = 1;
const STATO_MEMORIZZAZIONE = 2;//utilizzato per eseguire le operazioni di inserimento/modifica/eliminazione record
const STATO_ERRORE_CONNESSIONE = 3;
const STATO_OPERAZIONE_FALLITA = 4;
const STATO_RICERCA_DATI = 5;//utilizzato nel caso modifica e cancella quando vado a ricercare i dati per popolare i campi della scheda
const STATO_RICERCA_DATI_CORRETTA = 6;//utilizzato a valle della ricerca dati record in caso di modifica o cancellazione di un record


function FormGridFormRow(props) {
    
    const [operazione,setOperazione] = useState('');
    const [variazioneCampi,setvariazioneCampi]=useState(0);
    
    const [flagAttivaModaleRisorsaNonCancellabile, setFlagAttivaModaleRisorsaNonCancellabile] = useState(0);
    const [flagAttivaModaleRisorsaNonModificabile, setFlagAttivaModaleRisorsaNonModificabile] = useState(0);
    const [flagAttivaModaleRisorsaNonInseribile, setFlagAttivaModaleRisorsaNonInseribile] = useState(0);
    const [flagAttivaModaleInserisciDescrizione, setFlagAttivaModaleInserisciDescrizione] = useState(0);
    const [flagAttivaModaleRisorsaAlternativaErrata, setFlagAttivaModaleRisorsaAlternativaErrata] = useState(0);

    const descrizione   = useRef();
    const [statoPagina,setStatoPagina]=useState(STATO_INDEFINITO);
    const [error,setError]=useState('');
    //const [risultatoServer,setRisultatoServer]=useState('');
    //let descrizioneDefault = "";
    const [descrizioneDefault,setDescrizioneDefault] = useState('');

    const [risultatoServerDatiRisorse,setRisultatoServerDatiRisorse]=useState('');
    const [statoTendinaRisorse,setStatoTendinaRisorse]=useState(false);
    const [insRisorseEdi,setInsRisorseEdi]=useState('');
    //const [defaultRisorse,setDefaultRisorse]=useState('');
    const [variazioneCampiTendinaRisorse,setVariazioneCampiTendinaRisorse]=useState(0);

    const [disabilitaBottoni,setDisabilitaBottoni]= useState(false);
    const [loading,setLoading]= useState(false);
   

    useEffect(() => {
        setStatoPagina(STATO_INSERISCI);
    },[]);

    useEffect(() => {
        if(statoTendinaRisorse === true){
            setStatoPagina(STATO_RICERCA_DATI_CORRETTA);
        }
    },[statoTendinaRisorse]);

    useEffect(() => {
        if(props.ope==='inserisci') setOperazione("risorseIns");
        if(props.ope==='modifica') setOperazione("risorseMod");
        if(props.ope==='cancella') setOperazione("risorseCanc");

        if(props.ope==="modifica" || props.ope==="cancella"){
            //devo eseguire una fetch per popolare i campi della scheda con i dati presi da db per il record in esame:
            // parametri per inviare i dati al server:
            const requestOptions = {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({op:"risorseRecuperaDati",
                    id:props.id,
                    emak: props.emak,
                    sessionId:props.sessionId
                })
            };
            setStatoPagina(STATO_RICERCA_DATI);

            fetch(Parametri("serverURL",props.identitaSelezionata), requestOptions)
            .then(risposta => risposta.json())
            .then(
                (valoreDiRitorno) => {
                    if(valoreDiRitorno.risultatoOperazione!==1 && valoreDiRitorno.risultatoOperazione!==2){
                        alert("Si è verificato un errore gestendo la richiesta, se l'errore persiste contattare l'assistenza tecnica");
                    }
                    if(valoreDiRitorno.risultatoOperazione===2) props.setPagina(props.PAGINE.tornaLogin);
                    if(valoreDiRitorno.risultatoOperazione===1){
                    //setRisultatoServer(valoreDiRitorno.risultatoRitorno);
                    setDescrizioneDefault(valoreDiRitorno.risultatoRitorno[0].DESCRIZIONE);
                    setStatoPagina(STATO_RICERCA_DATI_CORRETTA);
                    }
                    },
                (error) => {setError(error);setStatoPagina(STATO_ERRORE_CONNESSIONE);}
            ); 
        }else setStatoPagina(STATO_RICERCA_DATI_CORRETTA);
    },[props.ope]);

    function tornaElenco() {
        props.callbackTermineModifica();
    }

    function tornaScheda(valore) {
        //setFlagAttivaModaleRisorsaNonCancellabile(0);
        setFlagAttivaModaleRisorsaNonModificabile(0);
        setFlagAttivaModaleRisorsaNonInseribile(0);
        setFlagAttivaModaleInserisciDescrizione(0);
        setFlagAttivaModaleRisorsaAlternativaErrata(0);
    }

    function handleCambiamentoMod(event) {
        //event.preventDefault();
        setvariazioneCampi(1);
    }


    function fetchOperazioneServer(bypassaControlli=0) {
        //invio l'azione da fare sul server (aggiungi/togli) e l'elemento in esame al server che mi ritornerà l'elenco aggiornato
        let controlli=0;
        //cancello comunque;
        if(props.ope!=='cancella' && bypassaControlli===0){
            if(descrizione.current.value=== ''){
                controlli = 1;
                setFlagAttivaModaleInserisciDescrizione(1);
            }
        }

        if(controlli===0){ 

            if(props.ope==='modifica' && variazioneCampi===0){
                //in relatà non e stata fatta alcuna variazione nei campi originali per cui torno ad elenco:
                tornaElenco();
            }else{
                setLoading(true);
                // parametri per inviare i dati al server:
                const requestOptions = {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: props.ope!=='cancella' ?  
                        JSON.stringify({op:operazione,
                        descrizione:descrizione.current.value,
                        idElemento:props.id,
                        emak: props.emak,
                        sessionId:props.sessionId
                    })
                    : 
                        JSON.stringify({op:operazione,
                        risorsa:insRisorseEdi,
                        idElemento:props.id,
                        emak: props.emak,
                        sessionId:props.sessionId})
                };
            
                // qui faccio la chiamata alla pagina sul server, quindi ne leggo la risposta che io trasformo in oggetto json 
                // con .json() ottenendo "valore_di_ritorno": in questo oggetto json ho "risultato_ritorno" che metto nella 
                // variabile di stato "risultato_server"
                //setStatoPagina(STATO_MEMORIZZAZIONE);

                fetch(Parametri("serverURL",props.identitaSelezionata), requestOptions)
                    .then(risposta => risposta.json())
                    .then(
                    (valoreDiRitorno) => {
                        setLoading(false);
                        if(valoreDiRitorno.risultatoOperazione===1) tornaElenco();
                        if(valoreDiRitorno.risultatoOperazione===2) props.setPagina(props.PAGINE.tornaLogin);
                        if(valoreDiRitorno.risultatoOperazione!==1 && valoreDiRitorno.risultatoOperazione!==2){
                            if(valoreDiRitorno.mess !== undefined){
                                if(valoreDiRitorno.mess.indexOf("Risorsa non cancellabile: presente in prima nota") !== -1){
                                    setRisultatoServerDatiRisorse(valoreDiRitorno.risorse);
                                    setStatoTendinaRisorse(true);//questa poi settere tramite useffect lo stato pagina in STATO_RICERCA_DATI_CORRETTA
                                    setFlagAttivaModaleRisorsaNonCancellabile(1);

                                } 
                                if(valoreDiRitorno.mess.indexOf("Risorsa non modificabile: presente altro record uguale") !== -1){
                                    setFlagAttivaModaleRisorsaNonModificabile(1);
                                }
                                if(valoreDiRitorno.mess.indexOf("Risorsa non inseribile: presente altro record uguale") !== -1){
                                    setFlagAttivaModaleRisorsaNonInseribile(1);
                                }
                                if(valoreDiRitorno.mess.indexOf("Descrizione non valorizzata") !== -1){
                                    setFlagAttivaModaleInserisciDescrizione(1);
                                }
                                if(valoreDiRitorno.mess.indexOf("Risorsa alternativa non presente nel db") !== -1){
                                    setFlagAttivaModaleRisorsaAlternativaErrata(1);
                                }
                                
                            }else{
                                //altrimenti vado in errore generico
                                setStatoPagina(STATO_OPERAZIONE_FALLITA);
                            }
                        }
                    },
                    (error) => {setLoading(false);setError(error);setStatoPagina(STATO_ERRORE_CONNESSIONE);}
                );
            }
        }
    }
/*
    if(statoPagina === STATO_RICERCA_DATI_CORRETTA){
        {risultatoServer != undefined && risultatoServer != "" ? descrizioneDefault= risultatoServer[0].DESCRIZIONE :""}
    }
 */   
    
        return (
            <>
                
                {/*eccola {props.sessionId}*/}
            
                {statoPagina === STATO_MEMORIZZAZIONE ? <Card className="main-card mb-3"><Clessidra loading={true}/></Card> :""}
                {statoPagina === STATO_ERRORE_CONNESSIONE ? <div>Errore: 1Ris {error.message}</div> :""}
                {statoPagina === STATO_OPERAZIONE_FALLITA ? <div>Errore per operazione errata</div> :""}
                {statoPagina === STATO_RICERCA_DATI ? <Card className="main-card mb-3"><Clessidra loading={true}/></Card> :""}

                {statoPagina === STATO_RICERCA_DATI_CORRETTA ?
                <div className="schedaContenitore" style={{height: props.dimensioniApp.yMain}}>

                    {flagAttivaModaleInserisciDescrizione===1 ?
                        <Modale 
                            titolo="Richiesta descrizione"
                            flagErrore={true}
                            contenuto={<div>Non è stata indicata la descrizione, che è necessaria</div>}
                            bottoni={[
                                {
                                    "etichetta":"OK",
                                    "tipo":"primary",
                                    callback:() => {setDisabilitaBottoni(false);tornaScheda()}
                                }    
                            ]}
                        />
                    :""}

                    {flagAttivaModaleRisorsaNonCancellabile=== 1 ?
                        <Modale 
                        titolo="Informativa risorsa non cancellabile"
                        flagErrore={true}
                        contenuto={<div><Row><Col>
                            <center>La risorsa risulta associata ad uno o più movimenti di prima nota. 
                            Per eliminarla è necessario selezionare una delle altre risorse attualmente esistenti alla quale associare i movimenti di prima nota attualmente associati alla risorsa che si intende eliminare</center>
                            </Col></Row>
                            <Row><Col><center><TendinaEditabile
                                titolo={"Risorsa"}
                                nomeCampo="DESCRIZIONE"
                                valoreDefault={insRisorseEdi}
                                bloccoInserimento="1"
                                arrayValori={risultatoServerDatiRisorse}
                                callbackSetVariazioneCampi={setVariazioneCampiTendinaRisorse}
                                callbackSetValoreTendEditabile={setInsRisorseEdi}
                            ></TendinaEditabile></center>
                            </Col></Row>
                            </div>}
                        bottoni={[
                            {
                                "etichetta":"OK",
                                "tipo":"primary",
                                callback:() => {setDisabilitaBottoni(false);fetchOperazioneServer()}
                            }, 
                            {
                                "etichetta":"Annulla",
                                "tipo":"primary",
                                callback:() => {setDisabilitaBottoni(false);tornaElenco()}
                            }   
                        ]}
                    />
                    :""}

                    {flagAttivaModaleRisorsaAlternativaErrata=== 1 ?
                        <Modale 
                        titolo="Informativa risorsa alternativa errata"
                        flagErrore={true}
                        contenuto={<div>La risorsa alternativa fornita non risulta presente nel database</div>}
                        bottoni={[
                            {
                                "etichetta":"OK",
                                "tipo":"primary",
                                callback:() => {setDisabilitaBottoni(false);tornaScheda()}
                            }    
                        ]}
                    />
                    :""}

                    {flagAttivaModaleRisorsaNonModificabile=== 1 ?
                        <Modale 
                        titolo="Informativa risorsa non modificabile"
                        flagErrore={true}
                        contenuto={<div>La descrizione della risorsa non è modificabile in {descrizione.current.value} poichè nel database è già presente una risorsa con la stessa descrizione</div>}
                        bottoni={[
                            {
                                "etichetta":"OK",
                                "tipo":"primary",
                                callback:() => {setDisabilitaBottoni(false);tornaScheda()}
                            }    
                        ]}
                    />
                    :""}

                    {flagAttivaModaleRisorsaNonInseribile=== 1 ?
                        <Modale 
                        titolo="Informativa risorsa non inseribile"
                        flagErrore={true}
                        contenuto={<div>La risorsa {descrizione.current.value} non è inseribile in poichè nel database è già presente una risorsa con la stessa descrizione</div>}
                        bottoni={[
                            {
                                "etichetta":"OK",
                                "tipo":"primary",
                                callback:() => {setDisabilitaBottoni(false);tornaScheda()}
                            }    
                        ]}
                    />
                    :""}

                    <div className="schedaSpazioCentrale" style={{height: props.dimensioniApp.yMain}}>
                            {props.ope === "inserisci" ? <CardTitle>Inserimento Risorsa</CardTitle> :""}
                            {props.ope === "modifica" ? <CardTitle>Modifica Risorsa</CardTitle> :""}
                           
                            
                            <Clessidra loading={loading}/>
                            {props.ope === "cancella" ?
                                <FinestraDialogo 
                                    titolo="Conferma eliminazione"
                                    flagErrore={true}                                
                                    contenuto={<div>
                                        Confermi l'eliminazione della risorsa <b>{descrizioneDefault}</b> ?<br/>                                    
                                    </div>}
                                    bottoni={[
                                        {
                                            "etichetta":"Conferma",
                                            "tipo":"primary",
                                            callback:() => {setDisabilitaBottoni(true);fetchOperazioneServer()}
                                        },
                                        {
                                            "etichetta":"Annulla",
                                            "tipo":"primary",
                                            callback: () => {tornaElenco()}
                                        }
                                    ]}
                                />                        

                            :
                                <>
                                <Row form>  
                                    <Col md={12}>
                                        <FormGroup>
                                            <Label for="descrizione">Descrizione*</Label>
                                            {props.ope === "inserisci" || props.ope === "modifica" ?
                                                <Input maxLength={200} type="text" name="descrizione" id="descrizione"
                                                innerRef={descrizione} 
                                                placeholder=""
                                                defaultValue={descrizioneDefault}
                                               onInput={(e)=>{handleCambiamentoMod(e);setDescrizioneDefault(descrizione.current.value)}}/> 
                                            :""}
                                         
                                        </FormGroup>
                                    </Col>
                                </Row>
                                </>
                            }
                                
                                 
                                </div>

                                <div className="schedaSpazioInferiore">
                                {props.ope === "inserisci" ? <Button disabled={disabilitaBottoni} color="success" className="mt-2 bottoneMargineADestra" onClick={() => {setDisabilitaBottoni(true);fetchOperazioneServer()}}>Inserisci</Button> :""}
                                {props.ope === "modifica" && variazioneCampi === 1? <Button disabled={disabilitaBottoni} color="warning" className="mt-2 bottoneMargineADestra" onClick={() => {setDisabilitaBottoni(true);fetchOperazioneServer()}}>Memorizza Modifiche</Button>:""}
                           
                                <Button disabled={disabilitaBottoni} color="primary" className="mt-2 bottoneMargineADestra" onClick={() => tornaElenco()} >
                                {(variazioneCampi === 1 && props.ope === "modifica") ?  <Fragment> Annulla </Fragment>: <Fragment>Torna all'elenco</Fragment>}
                                </Button>
                                </div>
                            
                </div>
                :""}
            </>
        );
}
export default FormGridFormRow;
